import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=85247914&scoped=true"
import script from "./billing.vue?vue&type=script&lang=js"
export * from "./billing.vue?vue&type=script&lang=js"
import style0 from "./billing.vue?vue&type=style&index=0&id=85247914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85247914",
  null
  
)

export default component.exports